import React, { useCallback, useEffect, useState } from "react";
import { PARTY_SCOPE } from "../apiContract";
import { getCreditNotes } from "../service";
import CreditNoteListTable from "./CreditNoteListTable";

const toErrorText = (err, fallback) => {
  const candidate = err?.response?.data?.error?.message ?? err?.message ?? fallback;
  return typeof candidate === "string" ? candidate : fallback;
};

export default function CreditNoteListSection({
  partyScope = PARTY_SCOPE.DEALER,
  detailLinkPrefix,
}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [creditNotes, setCreditNotes] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await getCreditNotes({ partyScope });
      setCreditNotes(payload.credit_notes ?? []);
    } catch (e) {
      setError(toErrorText(e, "Unable to load credit notes."));
      setCreditNotes([]);
    } finally {
      setLoading(false);
    }
  }, [partyScope]);

  useEffect(() => {
    load();
  }, [load]);

  const prefix =
    detailLinkPrefix ||
    (partyScope === PARTY_SCOPE.DIRECT_BUYER
      ? "/credit-notes"
      : "/dealer/credit-notes");

  return (
    <CreditNoteListTable
      creditNotes={creditNotes}
      loading={loading}
      error={error}
      showCustomerColumn={partyScope === PARTY_SCOPE.DEALER}
      detailLinkPrefix={prefix}
    />
  );
}
